<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div v-if="userAuthClass">
          <v-btn color="pink" flat router :to="{name: 'userAuthClass'}">
            <v-icon left>{{$store.state.global.pages.userAuthClass.icon}}</v-icon>User Authorization...
          </v-btn>
        </div>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
      </layout-no-padding>

      <v-dialog
        v-model="addUserDialog"
        max-width="500px"
        @keydown.esc="addUserDialog = false"
        v-if="userAuthClass"
      >
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-user" slot="activator">
          <v-icon dark>add</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-user @close="addUserDialog = false"></add-user>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import AddUser from "@/components/users/addUser";
import RouteProps from "@/services/mixins/routeProps";

//GET RECORDS
import getUsers from "@/services/mixins/getMasterFiles/getUsers";
export default {
  mixins: [
    //UserValidation,
    RouteProps,
    getUsers
  ],
  data() {
    return {
      addUserDialog: false,
      sortFactors: [
        {
          value: "id",
          text: "ID"
        },
        {
          value: "name",
          text: "Name"
        },
        {
          value: "userAuthClass.name",
          text: "Authorization"
        },
        {
          value: "updatedAt",
          text: "Updated At"
        }
      ]
    };
  },
  methods: {
    // toggleView() {
    //     this.listView = !this.listView;
    // },
    sortUsers(path1, path2) {
      return this.users.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1;
        } else {
          return 1;
        }
      });
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "users", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "users", prop: "filterBy" })
    //listView: Store.getSet({store: 'users', prop: 'listView'})
  },
  components: {
    AddUser
  },
  watch: {}
};
</script>

<style scoped>
</style>
